import FormControl from "../../../MUI_components/FormControl/fomikFormControl";
import { Form, Formik } from "formik";
import React, { useRef } from "react";
import ReactToPrint from "react-to-print";
import { pageStyle } from "../../../Print/printPagesStyles";
import reportsService from "Service/Reports/reports.service";
import BasicTable from "../../../MUI_components/Table/basicTable";
import ReportPrintTable from "../../reportPrintTable";
import { Button, Paper } from "@mui/material";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { openSnackbar } from "../../../../Redux/Actions/snackbarActions";
import supplierService from "Service/Suppliers/supplier.service";

import { COLUMNS_NAME } from "Components/Constants/ColumnsNames";
import { DownloadTableExcel } from "react-export-table-to-excel";
import Reports from "Components/Reports/reports";
import Footer from "titum-layouts/shared-components/Footer";
import Title from "Components/Card/title";
import { LOCAL_STORAGE } from "Components/Constants/LocalStorage";


export default function SupplierList() {
  const dispatch = useDispatch();
  const [supplierList, setSupplierList] = React.useState({
    rows: [],
    status: null,
    loading: false,
  });
  const tableRef = useRef(null);
  const formikRef = useRef(null);


  const HeadCells = [
    {
      key: (val) => {
        return val["code"];
      },
      align: "left",
      label: COLUMNS_NAME.CODE,
    },
    {
      key: (val) => {
        return val["name"];
      },
      align: "left",
      label: COLUMNS_NAME.SUPPLIER,
    },
    {
      key: (val) => {
        return val["phone1"];
      },
      align: "center",
      label: COLUMNS_NAME.TEL+ - +1,
    },
    {
      key: (val) => {
        return val["phone2"];
      },
      align: "center",
      label: COLUMNS_NAME.TEL + - +2,
    },
    {
      key: (val) => {
        return val["address1"];
      },
      align: "center",
      label: COLUMNS_NAME.ADDRESS,
    },

  ];

  const componentRef = React.useRef();
  //const componentRef = React.createRef();
  // useEffect(() => {
  //   const fetchSuppliers = async (values) => {
  //     setSupplierList({
  //       ...supplierList,
  //       loading: true,
  //     });
  //     try {
  //       const res = await supplierService.getAll();
  //       setSupplierList({
  //         loading: false,
  //         rows: res,
  //       });
  //     } catch (e) {
  //       dispatch(openSnackbar(true, "error", e));
  //     }
  //   };
  //  fetchSuppliers();
  // }, []);



  const handleSubmit = async (values) => {
    setSupplierList({
      ...supplierList,
      loading: true,
    });
    try {
      const res = await reportsService.SupplierList(values.supplier?.code);
      // console.log(res);
      setSupplierList({
        loading: false,
        rows: res.supplierlist,
        supplier: values.supplier,
      });
    } catch (e) {
      dispatch(openSnackbar(true, "error", e));
    }
  };

  const handleReset = () => {
    if(formikRef) {
      formikRef?.current.resetForm();
    }
    setSupplierList({
      rows: [],
      item: null,
      loading: false,
   })
  }

  //const billTotal = cheques.rows
  //.map((props) => parseFloat(props["total"]))
  //.reduce((sum, i) => sum + i, 0);

  // const Validation = yup.object({
  //   supplier: yup.object().required("Supplier is Required").nullable(),
  // });

  return (
    <div style={{ display: 'flex', width: '100%' }}>
    <div >
      <Reports />
    </div>
    <div style={{width: '100%'}}>
      <Formik
       innerRef={formikRef}
        initialValues={{
          supplier: "",
        }}
        //validationSchema={Validation}
        onSubmit={handleSubmit}
      >
        {(props) => {
          return (
            <Form>
               <Title>Suppliers list</Title>
              <div className="flex mt mb">
                <div className="col-4">
                  <FormControl
                    control="asynchronousAutoComplete"
                    name="supplier"
                    size="small"
                    label="Supplier"
                    Service={supplierService}
                    getOptionLabel={(option) => option.name +
                      " " +
                      option.code} />
                </div>
                <div className="col-1">
                  <Button variant="contained"
                    type="submit"
                    color="primary"
                    disabled={props.isSubmitting}
                  >
                    Find
                  </Button>
                </div>
                <div className="col-1">
                  <Button onClick={handleReset} variant="contained" color="error">
                    Clear
                  </Button>
                </div>

                
              </div>
            </Form>
          );
        } }
      </Formik>
      <Paper>
        <div className="flex-end">
          <ReactToPrint
            trigger={() => (
              <Button
                style={{ margin: 5 }}
                disabled={!supplierList.rows.length}
                variant="contained"
              >
                Print
              </Button>
            )}
            content={() => componentRef.current}
            pageStyle={pageStyle.a4} />
          <DownloadTableExcel
            filename="ageingSummery"
            currentTableRef={tableRef.current}
          >
            <Button
              style={{ margin: 5 }}
              disabled={!supplierList.rows.length}
              variant="contained"
            >
              Export to Excel </Button>
          </DownloadTableExcel>
        </div>
        <div style={{ display: "none" }}>

            <Reports
             >
                          <div ref={componentRef}>
              <ReportPrintTable
   title={`Supplier List - ${supplierList?.supplier?.name} Location : ${JSON.parse(localStorage.getItem(LOCAL_STORAGE.BIZX_LOCATION)).name}`}

                headCells={HeadCells}
                rows={supplierList.rows}
                 />
                   </div>
            </Reports>
       
        </div>

        <BasicTable
          headCells={HeadCells}
          rows={supplierList.rows}
          isLoaded={supplierList.loading}
          tableRef={tableRef} />
      </Paper>
    </div>
    </div>
  );
}